module.exports = "/images/cover-8.jpg";